import cx from 'classnames';
import * as React from 'react';

import './styles/ListItem.scss';

type Props = {
  children?: React.ReactNode;
  className?: string;
};

export default function ListItem({ children, className, ...props }: Props) {
  return (
    <li {...props} className={cx('ListItem', className)}>
      {children}
    </li>
  );
}
